export const types = {
  OPEN: 'SIDEBAR_OPEN',
  CLOSE: 'SIDEBAR_CLOSE',
  PUSH: 'SIDEBAR_PUSH',
};
export const openSidebar = () => ({
  type: types.OPEN,
});

export const closeSidebar = (active) => ({
  type: types.CLOSE,
  active,
});

export const push = ({ route, active }) => ({
  type: types.PUSH,
  route,
  active,
});



// WEBPACK FOOTER //
// ./redux/actions/sidebar.js